import React, { useEffect } from 'react'
import {
    Route,
    Routes, Outlet,
    useSearchParams, Navigate,
} from 'react-router-dom-v5-compat'

import ActivateBusyMode from './ActivateBusyMode'
import OrdersFinished from './OrdersFinished'
import OrdersCurrent from './OrdersCurrent'
import OrderDetail from './OrderDetail'
import useUser from '../Shared/UserProvider/useUser'
import { useTranslation } from 'react-i18next'
import { OrderDetailProvider } from './OrderDetail/OrderDetailContext'
import useBreadcrumb from '../NavBar/useBreadcrumb'
import OrdersUntreated from './OrdersUntreated'
import { PickingProofsGallery } from './PickingProof/PickingProofsGallery'
import { OrderItemReplacement } from './OrderDetail/OrderItemList/OrderItemFulfillment/OrderItemReplacement'
import { OrdersLists } from './OrdersLists'

const OrderDetailWithProvider = () => (
  <OrderDetailProvider>
      <OrderDetail/>
  </OrderDetailProvider>
)

const OrdersIndex = () => {
    const [t] = useTranslation()
    const {user} = useUser()
    const {setPaths} = useBreadcrumb()
    const [searchParams] = useSearchParams()
    const hideNavBar = JSON.parse(searchParams.get('hideNavBar'))

    useEffect(() => {
        setPaths([{
            text: t('breadcrumb.home'),
            link: true,
            path: '/',
        }, {
            text: t('breadcrumb.orders'),
            link: false,
        }])
    }, [])

    return (
      <>
          {(!hideNavBar && user?.provider?.object?.company?.id !== '92b73161-e6ab-4581-b603-63bbe27b6c55') && (
            <ActivateBusyMode />
          )}
          <Routes>
              <Route path="orders">
                  <Route index element={<Navigate to="current" replace />} />
                  <Route element={<OrdersLists />}>
                      <Route path="current" element={<OrdersCurrent />} />
                      <Route path="finished" element={<OrdersFinished />} />
                      <Route path="untreated" element={<OrdersUntreated />} />
                  </Route>

                  <Route path=":id">
                      <Route index element={<OrderDetailWithProvider />} />
                      <Route path="picking-proofs" element={<PickingProofsGallery />} />
                      <Route path="items/:orderItemId/replacement" element={<OrderItemReplacement />} />
                  </Route>
              </Route>
          </Routes>

          <Outlet />
      </>
    )
}

export default OrdersIndex
